import React from 'react'

import styled, { useTheme } from 'styled-components/native'

import { ExternalLinkIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/ExternalLinkIcon'
import { Link } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/link/Link'
import { BodyTextSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

interface EligibilityMessageWithLinksProps {
  message: string | undefined
}

export const EligibilityMessageWithLinks: React.FC<EligibilityMessageWithLinksProps> = ({ message }) => {
  const { colors: themeColors } = useTheme()

  const Container = styled.View({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  })

  const renderLearnMoreLink = () => (
    <Container>
      <Link
        text={
          <>
            Learn more <ExternalLinkIcon strokeColor={themeColors.linkDefault} />
          </>
        }
        onPress={() =>
          window.open(
            'https://lyrahealth.zendesk.com/knowledge/articles/6650922178835/en-us?brand_id=1106368',
            '_blank',
          )
        }
        testID={tID('EligibilityMessageWithLinks-learnMoreLink')}
        size={BodyTextSize.SMALL}
        style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
      />
    </Container>
  )

  if (!message) return null
  if (message.includes('providers@lyrahealth.com')) {
    const emailAddress = 'providers@lyrahealth.com'
    const parts = message.split(emailAddress)
    return (
      <>
        {parts.map((part, index) => (
          <React.Fragment key={index}>
            {part}
            {index < parts.length - 1 && (
              <Link
                text='provider support'
                onPress={() => window.open('https://provider-support.lyrahealth.com/hc/en-us/requests/new', '_blank')}
                testID={tID('EligibilityMessageWithLinks-providerSupportLink')}
                size={BodyTextSize.SMALL}
                underline
              />
            )}
          </React.Fragment>
        ))}
        {renderLearnMoreLink()}
      </>
    )
  }
  return (
    <>
      {message}
      {renderLearnMoreLink()}
    </>
  )
}
